import { Link } from 'react-router-dom';

export default function WhySpreadsheetSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Image */}
          <div className="w-full lg:w-[45%]">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20view%20of%20a%20minimalist%20desk%20with%20open%20notebook%20filled%20with%20handwritten%20comparison%20notes%2C%20a%20steaming%20ceramic%20mug%20of%20coffee%2C%20scattered%20fabric%20swatches%20in%20terracotta%20and%20sand%20colors%2C%20golden%20morning%20light%20from%20side%20window%2C%20warm%20organic%20textures%2C%20calm%20productive%20atmosphere%2C%20no%20text%2C%20editorial%20workspace%20photography&width=800&height=600&seq=why-section-v3&orientation=landscape"
                alt="PandabuySpreadsheet data-driven shopping experience"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="w-full lg:w-[55%]">
            <p className="text-sm font-semibold text-primary-500 tracking-widest uppercase mb-3">
              Why PandabuySpreadsheet Works
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              Transform the Way You
              <br />
              <span className="text-foreground-600">Compare Products Online</span>
            </h2>
            <div className="space-y-5">
              <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                Traditional product browsing is chaotic and time-consuming. Endless scrolling through
                listings without structure leads to poor decisions and wasted money. The PandabuySpreadsheet
                approach transforms raw product data into structured, comparable insights that help users
                quickly identify value, quality, and the best alternatives across every category.
              </p>
              <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
                By organizing product information into clean spreadsheet formats, you can compare prices,
                features, and ratings side by side. This data-driven methodology eliminates guesswork
                and empowers you to make confident buying decisions backed by real structured data.
              </p>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <Link
                to="/blog/pandabuy-spreadsheet-comparison-guide"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 font-semibold text-sm hover:border-foreground-400 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}